import {getRestrictedTo, VisitorType} from '@wix/wix-events-commons-statics'
import {State} from '../types/state'

export const membersEnabled = (state: boolean = false): boolean => state

export const isRestrictedTo = (event: wix.events.Event, state: State, visitorType: VisitorType) =>
  state.membersEnabled && getRestrictedTo(event) === visitorType
